import React, { useState, useEffect } from "react";
import VisibilityApi from "../state/Visibility-api";
import { lclContainerBulkUpdate } from "../StaticData";
import { configStore, dataListStore } from "../state/CommonState";
import Api from "../state/Api";
import { loader } from "../util/loader";
import BookingsApi from "../state/bookings-api";
import { myactionsstore } from "./store-myactions";

const ContainerUpdatePopup = ({ visible, setVisible, fl_vessel_name, setFlVesselName }) => {
  const [containerNo, setContainerNo] = useState(fl_vessel_name || "");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [container, setContainer] = useState({});
  const [searchText, setSearchText] = useState('');
  const [containerList, setContainerList] = useState([]);
  const [showContainerList, setShowContainerList] = useState(false);

  useEffect(() => {
    Api.getFCLCarrierList();
  }, []);

  useEffect(() => {
    setContainerNo(fl_vessel_name || "");
  }, [fl_vessel_name]);

  useEffect(() => {
    const regex = /^[A-Z]{4}\d{7}$/;

    if (regex.test(containerNo)) {
      const checkContainer = async () => {
        setChecking(true);
        setError("");

        try {
          loader.show();
          const res = await VisibilityApi.containerUpdate({
            container_number: containerNo,
            update: false,
          });
          if (res?.exists) {
            setContainer(res.exists || {});
            setDisabled(false);
          } else {
            setError("This container number doesn't exist.");
          }
        } catch (err) {
          console.error(err);
          setError("Error checking container number.");
        } finally {
          setChecking(false);
          loader.hide();
        }
      };

      checkContainer();
    } else {
      setContainer({});
      setDisabled(true);
    }
  }, [containerNo]);

  const handleClose = () => {
    setContainer({});
    setDisabled(true);
    setContainerNo("");
    setShowContainerList(false);
    setSearchText('');
    setVisible(false);
  };

  const handleSave = async () => {
    try {
      loader.show();
      const res = await VisibilityApi.containerUpdate({
        ...container,
        container_number: containerNo,
        update: true,
      });
      if (res?.updated) {
        configStore.setModalMessage(`${res.modifiedCount} booking(s) updated.`);
        setContainer({});
        setDisabled(true);
        setContainerNo("");
        setShowContainerList(false);
        setSearchText('');
        setVisible(false);
        configStore.modalvisibledata = {}
        if (myactionsstore.recheck === 0) {
          myactionsstore.recheck = 1
        } else {
          myactionsstore.recheck = 0
        }
      } else {
        setError("This container number doesn't exist.");
      }
    } catch (err) {
      console.error(err);
      setError("Error checking container number.");
    } finally {
      loader.hide();
    }
  };

  const fetchContainerList = async () => {
    try {
      loader.show();
      if (!showContainerList) {
        const res = await new Promise((resolve, reject) => {
          BookingsApi.getContainerList((data) => resolve(data));
        });
        setContainerList(res || []);
        setShowContainerList(true);
      } else {
        setShowContainerList(false);
      }
    } catch (err) {
      console.error(err);
      configStore.setModalMessage("Failed to fetch container list.");
    } finally {
      loader.hide();
    }
  };

  if (!visible) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={handleClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">LCL Container Update</p>
          <button className="delete" aria-label="close" onClick={handleClose}></button>
        </header>
        <section className="modal-card-body">
          <div className="field">
            <label className="label is-small">Container No</label>
            <div className="is-flex">
              <input
                className="input is-small"
                type="text"
                placeholder="ABCD1234567"
                value={containerNo}
                maxLength={11}
                onChange={(e) => {
                  let val = e.target.value.toUpperCase();

                  if (val.length <= 4) {
                    val = val.replace(/[^A-Z]/g, "");
                  } else if (val.length > 4) {
                    const firstPart = val.slice(0, 4).replace(/[^A-Z]/g, "");
                    const secondPart = val.slice(4).replace(/[^0-9]/g, "");
                    val = firstPart + secondPart;
                  }

                  setContainerNo(val);
                  setError("");
                }}
              />
              <button
                className="button is-small is-info ml-2"
                type="button"
                onClick={fetchContainerList}
              >
                Browse Container
              </button>
            </div>
            {checking && <p className="help is-info">Checking container...</p>}
            {error && <p className="help is-danger">{error}</p>}
          </div>

          {showContainerList && (
            <div className="mt-2 border rounded-md p-2 max-h-60 overflow-y-auto w-full">
              {/* Search Input */}
              <input
                type="text"
                className="input is-small mb-2"
                placeholder="Search container / POL / POD"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              {/* Filtered List */}
              {containerList.filter(c => {
                const search = searchText.toLowerCase();
                return (
                  c.pol_container_number.toLowerCase().includes(search) ||
                  (c.pol || '').toLowerCase().includes(search) ||
                  (c.pod || '').toLowerCase().includes(search)
                );
              }).length > 0 ? (
                containerList
                  .filter(c => {
                    const search = searchText.toLowerCase();
                    return (
                      c.pol_container_number.toLowerCase().includes(search) ||
                      (c.pol || '').toLowerCase().includes(search) ||
                      (c.pod || '').toLowerCase().includes(search)
                    );
                  })
                  .map((c, idx) => (
                    <div
                      key={idx}
                      className="p-2 hover:bg-gray-200 cursor-pointer border-b"
                      onClick={() => {
                        setContainerNo(c.pol_container_number);
                        setShowContainerList(false);
                      }}
                    >
                      <div className="font-semibold text-sm">POL: {c.pol || 'NA'} / POD: {c.pod || 'NA'}</div>
                      <div className="text-gray-700 text-xs mt-1">
                        Container: {c.pol_container_number}
                      </div>
                    </div>
                  ))
              ) : (
                <p className="p-2 text-gray-500">No containers found.</p>
              )}
            </div>
          )}

          <div className="columns is-multiline is-variable is-2">

            <div className="column is-half">
              <div className="field">
                <label className="label is-small">Carrier</label>
                <div className="control">
                  <div className="select is-small is-fullwidth">
                    <select
                      value={container.carrier || ""}
                      disabled={disabled}
                      onChange={(e) =>
                        setContainer({ ...container, carrier: e.target.value })
                      }
                    >
                      <option value="">Select Carrier</option>
                      {dataListStore["FCLCarrierList"]?.map((carrier, idx) => (
                        <option
                          key={idx}
                          value={`${carrier["Display Name"]} (${carrier["SCAC code"]})`}
                        >
                          {`${carrier["Display Name"]} (${carrier["SCAC code"]})`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {lclContainerBulkUpdate.map((field, idx) => (
              <div className="column is-half" key={idx}>
                <div className="field">
                  <label className="label is-small">{field.label}</label>
                  <div className="control">
                    <input
                      disabled={disabled}
                      className="input is-small"
                      type={field.type}
                      value={container[field.key] || ""}
                      onChange={(e) =>
                        setContainer({ ...container, [field.key]: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <footer className="modal-card-foot is-flex">
          <button className="button is-warning" onClick={handleClose}>
            Cancel
          </button>
          <div className="ml-auto">
            <button className="button is-link" onClick={handleSave} disabled={disabled}>
              Update
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ContainerUpdatePopup;
